import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-otp-timer',
  template: `
    <div class="timer-container">
      <svg class="timer-ring" viewBox="0 0 100 100">
        <!-- Teal background ring -->
        <circle class="ring-bg" cx="50" cy="50" r="45"></circle>
        <!-- White progress ring -->
        <circle
          class="ring-progress"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="offset"
          cx="50" cy="50" r="45"
        ></circle>
      </svg>
      <div class="timer-label">{{ count }}</div>
    </div>
  `
})
export class OtpTimerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() otpTimerSeconds!: number;
  @Input() resetFlag!: boolean;

  count!: number;
  circumference!: number;
  offset!: number;
  private intervalId: any;

  ngOnInit(): void {
    this.setupRing();
    this.startOrReset();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['otpTimerSeconds'] && !changes['otpTimerSeconds'].isFirstChange()) {
      this.setupRing();
    }
    if (changes['resetFlag'] && changes['resetFlag'].currentValue) {
      this.startOrReset();
    }
  }

  private setupRing(): void {
    const radius = 45;
    this.circumference = 2 * Math.PI * radius;
    this.offset = this.circumference; // start full cover
  }

  private startOrReset(): void {
    this.clear();
    this.count = this.otpTimerSeconds;
    this.updateProgress();
    this.intervalId = setInterval(() => {
      this.count--;
      this.updateProgress();
      if (this.count <= 0) this.clear();
    }, 1000);
  }

  private updateProgress(): void {
    const ratio = Math.max(this.count, 0) / this.otpTimerSeconds;
    // offset shrinks white cover clockwise, revealing teal bg
    this.offset = this.circumference * ratio;
  }

  private clear(): void {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  ngOnDestroy(): void {
    this.clear();
  }
}